import React, { useState } from 'react';
import { verifyPin } from '../utils/pin';

const KEYS = ['1','2','3','4','5','6','7','8','9','','0','⌫'];

/**
 * Full-screen PIN entry overlay.
 * Props:
 *   pinHash  — SHA-256 hash from profile.pin_hash
 *   userId   — for verifyPin salting
 *   onUnlock — called when correct PIN entered
 */
export default function PinLockScreen({ pinHash, userId, onUnlock }) {
  const [digits, setDigits]   = useState('');
  const [error,  setError]    = useState('');
  const [checking, setChecking] = useState(false);

  async function handleKey(key) {
    if (checking) return;
    if (key === '⌫') {
      setDigits((d) => d.slice(0, -1));
      setError('');
      return;
    }
    if (digits.length >= 4) return;
    const next = digits + key;
    setDigits(next);
    setError('');

    if (next.length >= 4) {
      setChecking(true);
      const ok = await verifyPin(next, pinHash, userId);
      setChecking(false);
      if (ok) {
        onUnlock();
      } else {
        setDigits('');
        setError('Incorrect PIN');
      }
    }
  }

  const dots = Array.from({ length: 4 }, (_, i) => i < digits.length);

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 9999,
      background: '#0d0d1a',
      display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
      userSelect: 'none',
    }}>
      {/* Bear logo / title */}
      <div style={{ marginBottom: '2rem', textAlign: 'center' }}>
        <img src="/bear-logo.png" alt="Bear Security" style={{ width: 60, height: 60, objectFit: 'contain', marginBottom: 8 }} />
        <div style={{ color: '#fff', fontWeight: 700, fontSize: '1.125rem', letterSpacing: '0.05em' }}>
          BEAR SECURITY
        </div>
        <div style={{ color: '#a0a8c0', fontSize: '0.8125rem', marginTop: '0.25rem' }}>
          Enter your PIN to continue
        </div>
      </div>

      {/* Dot indicators */}
      <div style={{ display: 'flex', gap: '0.875rem', marginBottom: '1.5rem' }}>
        {dots.map((filled, i) => (
          <div
            key={i}
            style={{
              width: 14, height: 14, borderRadius: '50%',
              background: filled ? '#4f8ef7' : 'transparent',
              border: '2px solid',
              borderColor: filled ? '#4f8ef7' : '#2a2a3e',
              transition: 'background 0.15s, border-color 0.15s',
            }}
          />
        ))}
      </div>

      {/* Error message */}
      <div style={{
        height: 20, marginBottom: '1rem',
        color: '#ef4444', fontSize: '0.875rem', fontWeight: 600,
      }}>
        {error}
      </div>

      {/* Numeric keypad */}
      <div style={{
        display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)',
        gap: '0.75rem',
        width: '100%', maxWidth: 260,
      }}>
        {KEYS.map((key, i) => {
          if (key === '') return <div key={i} />;
          return (
            <button
              key={i}
              onClick={() => key !== '' && handleKey(key)}
              disabled={checking}
              style={{
                width: '100%', aspectRatio: '1', borderRadius: '50%',
                background: '#1a1a2e',
                border: '1px solid #2a2a3e',
                color: '#fff',
                fontSize: key === '⌫' ? '1.375rem' : '1.5rem',
                fontWeight: 500,
                cursor: 'pointer',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                WebkitTapHighlightColor: 'transparent',
              }}
            >
              {key}
            </button>
          );
        })}
      </div>
    </div>
  );
}
